<!--<div fxLayout="column" fxFlex="80%" fxLayoutAlign="center center" fxLayoutGap="10px">

</div>-->
<!--<section class="list-translation">
  <div fxLayout="row" fxLayoutGap="30px">-->
<!--<mat-form-field >
  <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Filter" />
</mat-form-field>-->
<!--</div>

</section>-->
<div class="container">
  <div class="search-div">
    <button mat-raised-button (click)="onCreate()">
      <mat-icon>add</mat-icon>Create
    </button>
    <mat-form-field class="search-form-field" floatLabel="never" >
      <input matInput #Search type="text" placeholder="Search" (keyup)="doFilter($event.target.value)" >
      <button mat-button matSuffix mat-icon-button aria-label="Clear"  (click)="Search.value=''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field  class="translation-form-field">
      <mat-select placeholder="TranslationTypes" name="translationtypeid" (selectionChange)="filterForTypes($event.value)">
        <mat-option>All</mat-option>
        <mat-option *ngFor="let t of translationtypes" [value]="t.translationTypeId">
          {{t.translationTypeName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="20px">
    <mat-table [dataSource]="translationTableDataSource" fxFlex="1" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="translationId">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Translation ID  </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.translationId}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="original">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Original  </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.original}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="translated">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Translated  </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <!--<ng-container *ngIf="element.translated || element.translated !=''">
        {{element.translated}}
      </ng-container>-->
          <mat-form-field floatLabel="never">
            <input matInput placeholder="Translated" [value]="element.translated" [(ngModel)]="element.translated" (change)="update(element)">
          </mat-form-field>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ignore">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Ignore</mat-header-cell>
        <mat-cell *matCellDef="let element">  <mat-checkbox [(ngModel)]="element.ignore" name="ignore" #Ignore="ngModel"  (change)="update(element)"></mat-checkbox></mat-cell>
      </ng-container>
      <ng-container matColumnDef="translationTypeName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Translation Type  </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.translationTypeName}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="onEdit(element)"><mat-icon>launch</mat-icon></button>
          <button mat-icon-button color="warn" (click)="onDelete(element.translationId)"><mat-icon>delete_outline</mat-icon></button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="loading">
        <mat-footer-cell *matFooterCellDef colspan="4">
          Loading Data ....
        </mat-footer-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : filteredTranslations != null }"></mat-footer-row>
    </mat-table>
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10,20,100]">

    </mat-paginator>
  </div>
  <div>
    <button type="button" mat-raised-button color="warn" (click)="onGDrive()">Google Drive</button>
  </div>
  <!-- <div>
     <button type="button" mat-raised-button color="warn" (click)="onImportCSV()">Import CSV </button>
   </div>
   <div>
     <button type="button" mat-raised-button color="warn" (click)="onProcessTranslation()">Process Translation</button>
   </div>
   <div>
     <button type="button" mat-raised-button color="warn" (click)="onGenerateAds('9919')">Generate Ads</button>
   </div>-->
</div>
